jQuery(function ($) {
  "use strict";

  var init = [
    function () {
      if ($('.scroll-to-top').length) {
        let mybutton = document.getElementById("btn-back-to-top");

        // When the user scrolls down 150px from the top of the document, show the button
        window.onscroll = function () {
          scrollFunction();
        };

        function scrollFunction() {
          if (
            document.body.scrollTop > 150 ||
            document.documentElement.scrollTop > 150
          ) {
            mybutton.style.display = "block";
          } else {
            mybutton.style.display = "none";
          }
        }
        // When the user clicks on the button, scroll to the top of the document
        mybutton.addEventListener("click", backToTop);

        function backToTop() {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      } else {}
    },
    function () {
      if ($('.main-navigation .main-navigation__search .site-search').length) {
        $(".main-navigation .main-navigation__search .site-search").click(function(){
          $(".main-navigation .main-navigation__search .search-form").toggle();
        });
      }
    },
    function () {
      $(document).ready(function() {
        var modalInner = $('.modal__inner');
        modalInner.each(function() {
          var content = $(this);
          $(this).remove();
          $('.entry-content').append(content);
        });
      });
    },
      function () {
      new WOW(
        {
          boxClass:     'wp-block-column',
          animateClass: 'fadeIn',
          offset:       0,
          mobile:       false,
          live:         true,
        }
      ).init();
    },
    function () {
      new WOW(
        {
          boxClass:     'wp-block-cover__inner-container',
          animateClass: 'fadeInUp',
          offset:       0,
          mobile:       false,
          live:         true,
        },
      ).init();
    },
    function () {
      $(window).on('load', function menuStuff() {
        var headerHeight = $('.site-header').outerHeight();
        var body = $('body');
        var sticky = $('.site-header');
        let menu = $('#menu');
        let nav = $('.main-navigation__nav');

        // Function to handle sticky header
        function handleStickyHeader() {
          var scroll = $(window).scrollTop();

          if (scroll >= headerHeight) {
            sticky.addClass('site-header--sticky');
            body.css('padding-top', headerHeight);
          } else {
            sticky.removeClass('site-header--sticky');
            body.css('padding-top', 0);
          }
        }

        // Function to add or remove buttons based on viewport size
        function handleResponsiveMenu() {
          $('.site-header .menu .menu-item.menu-item-has-children').each(function() {
            if (!$(this).find('.menu-item-dropdown-toggle').length) {
              $(this).append('<button class="menu-item-dropdown-toggle"></button>');
            }
          });
        }

        function positionSubMenu() {
          var subMenus = document.querySelectorAll('.site-header .menu .menu-item.menu-item-has-children .sub-menu');

          subMenus.forEach(function(subMenu) {
            // Temporarily set the sub-menu to be visible
            subMenu.classList.add('sub-menu__active');

            var rect = subMenu.getBoundingClientRect();

            // Check if there's enough space on the right
            if (rect.right > window.innerWidth) {
              subMenu.classList.add('sub-menu--right');
            } else {
              subMenu.classList.remove('sub-menu--right');
            }

            // Hide the sub-menu again
            subMenu.classList.remove('sub-menu__active');
          });
        }

        // Initial call to handleStickyHeader to set the initial state
        handleStickyHeader();
        handleResponsiveMenu();
        positionSubMenu();

        // Bind scroll event to handleStickyHeader
        $(window).scroll(handleStickyHeader);

        // Bind resize event to handleResponsiveMenu
        $(window).resize(handleResponsiveMenu);

        // Bind resize event to positionSubMenu
        $(window).resize(positionSubMenu);

        // Set initial top position for mobile navigation
        $('.site-header .main-navigation .main-navigation__nav').css('top', headerHeight);

        menu.on('click', function(e) {
          $(this).toggleClass('is-open');
          nav.toggleClass('is-open');
        });

        // Toggle sub-menus when the dropdown button is clicked
        $(document).on(
          'click',
          '.site-header .menu .menu-item.menu-item-has-children > a',
          function (e) {

            var $link = $(this);
            var $parent = $link.closest('.menu-item-has-children');
            var $submenu = $parent.children('.sub-menu');
            var $toggle = $parent.children('.menu-item-dropdown-toggle');

            // If submenu is NOT open → open it instead of navigating
            if (!$submenu.hasClass('sub-menu__active')) {
              e.preventDefault();
              e.stopPropagation();

              // Close all others
              $('.sub-menu').not($submenu).removeClass('sub-menu__active');
              $('.menu-item-dropdown-toggle').not($toggle).removeClass('menu-item-dropdown-toggle--active');

              // Open this one
              $submenu.addClass('sub-menu__active');
              $toggle.addClass('menu-item-dropdown-toggle--active');

              // Lock scroll
              $('body').css('overflow', 'hidden');
            }
            // else → submenu is already open → allow browser to follow href
        });

        $('.site-header .menu .menu-item.menu-item-has-children .menu-item-dropdown-toggle').on('click', function(e) {
          e.preventDefault();
          var subMenu = $(this).siblings('.sub-menu');
          var allDropDowns = $('.menu-item-dropdown-toggle');

          // Close all open sub-menus and remove active class from all dropdown buttons
          $('.sub-menu').not(subMenu).removeClass('sub-menu__active');
          allDropDowns.not($(this)).removeClass('menu-item-dropdown-toggle--active');

          // Toggle active class for the clicked button and its submenu
          $(this).toggleClass('menu-item-dropdown-toggle--active');
          subMenu.toggleClass('sub-menu__active');

          // Disable scrolling on everything else when dropdown is open
          if (subMenu.hasClass('sub-menu__active')) {
            $('body').css('overflow', 'hidden');
          } else {
            $('body').css('overflow', ''); // Enable scrolling when dropdown is closed
          }

          e.stopPropagation(); // Stop the event from bubbling up to the document
        });

        // Close sub-menus when clicking outside of them
        $(document).click(function(e) {
          // Check if the clicked element is not a submenu or its parent button
          if (!$(e.target).closest('.sub-menu').length && !$(e.target).closest('.menu-item-dropdown-toggle').length) {
            // Remove the active class from all submenus and dropdown buttons
            $('.sub-menu').removeClass('sub-menu__active');
            $('.menu-item-dropdown-toggle').removeClass('menu-item-dropdown-toggle--active');

            // Enable scrolling when clicking outside the dropdown
            $('body').css('overflow', ''); // Enable scrolling
          }
        });
      }).init();
    },
    function () {
      const FIELD_WRAPPERS = [
          '.hsfc-TextField',
          '.hsfc-EmailField',
          '.hsfc-PhoneField',
          '.hsfc-NumberField',
          '.hsfc-DateField',
          '.hsfc-TextareaField'
      ].join(',');

      function update(field) {
          const root = field.closest(FIELD_WRAPPERS);
          if (!root) return;

          const label = root.querySelector('.hsfc-FieldLabel');
          if (!label) return;

          label.classList.toggle('filled', field.value && field.value.trim() !== '');
      }

      document.addEventListener('input', e => {
          if (e.target.matches('input, textarea')) update(e.target);
      });

      document.addEventListener('change', e => {
          if (e.target.matches('input, textarea')) update(e.target);
      });

      function init() {
          document.querySelectorAll(`${FIELD_WRAPPERS} input, ${FIELD_WRAPPERS} textarea`)
              .forEach(update);
      }

      document.addEventListener('DOMContentLoaded', init);
      document.addEventListener('hsFormReady', init);
      setTimeout(init, 300);
    },
    function () {
      function initFilledLabels() {
        document.querySelectorAll('.hsfc-DropdownField').forEach(field => {
          const label = field.querySelector('.hsfc-FieldLabel');
          const visibleInput = field.querySelector('input[type="text"][readonly]');
          const hiddenInput  = field.querySelector('input[type="hidden"]');

          if (!label || !visibleInput) return;

          function update() {
            // Use visible input value – it's what the user sees and usually stays in sync
            const value = (visibleInput.value || '').trim();
            if (value.length > 0) {
              label.classList.add('filled');
            } else {
              label.classList.remove('filled');
            }
          }

          // Run immediately (very important for pre-filled values)
          update();

          // Watch for changes – HubSpot often updates the visible input directly
          ['input', 'change'].forEach(evt => {
            visibleInput.addEventListener(evt, update);
          });

          if (hiddenInput) {
            ['input', 'change'].forEach(evt => {
              hiddenInput.addEventListener(evt, update);
            });
          }

          // Catch programmatic / framework-driven updates (common in HubSpot)
          const mo = new MutationObserver(update);
          mo.observe(visibleInput,  { attributes: true, attributeFilter: ['value'] });
          if (hiddenInput) {
            mo.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
          }

          // Fallback: poll lightly only if needed (comment out after testing)
          // setInterval(update, 1200);
        });
      }

      // Run now + retry a few times in case form loads async
      initFilledLabels();

      // These timeouts help if the form is injected after page load
      setTimeout(initFilledLabels,  800);
      setTimeout(initFilledLabels, 1800);
      setTimeout(initFilledLabels, 3500);
    },
    /*
    function () {
      $(document).ready(function() {

        const entryContent = document.querySelector('.wp-theme-mixan');
        const siteHeader = document.querySelector('.site-header');

        if (entryContent && siteHeader) {
          if (!entryContent.querySelector('.wp-block-mixan-hero-section')) {
            siteHeader.classList.add('site-header--inline');
          }
        }
      });
    },
    */
    function () {
      document.querySelectorAll('.post-like-btn').forEach(button => {
        const postId = button.dataset.post;
        const key = 'liked_' + postId;

        if (localStorage.getItem(key)) {
            button.classList.add('liked');
        }

        button.addEventListener('click', () => {
          if (localStorage.getItem(key)) return;

          fetch('/wp-json/likes/v1/toggle', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ post_id: postId })
          })
          .then(res => res.json())
          .then(data => {
            if (data.liked) {
              localStorage.setItem(key, '1');
              button.classList.add('liked');
              button.querySelector('.like-count').textContent = data.likes;
            }
          });
        });
      });
    },
    /*
    function () {
      var $stickyRow = $('.sticky-row');
      var $stickyRowStop = $('.sticky-row-stop');
      var $stickyRowPlaceholder = $('<div class="sticky-row-placeholder"></div>');

      // Wrap the sticky row with the placeholder
      $stickyRow.wrap($stickyRowPlaceholder);

      // Initially set the height of the placeholder
      $stickyRow.parent().height($stickyRow.outerHeight());

      var originalPos = $stickyRow.offset().top;
      var stopPos = $stickyRowStop.offset().top;
      var menuHeight = $('.site-header').outerHeight();
      var sharer = $('.social-media--sharing').outerHeight();

      var distanceToStop = stopPos - originalPos;

      $(window).scroll(function() {
        var scrollPos = $(window).scrollTop();

        if (scrollPos >= originalPos - menuHeight && scrollPos < stopPos - sharer - menuHeight - 10) {
          $stickyRow.addClass('sticky-row--stuck').removeClass('sticky-row--stopped');
          $stickyRow.css('top', menuHeight + 10);
        } else if (scrollPos >= stopPos - sharer - menuHeight - 10) {
          $stickyRow.removeClass('sticky-row--stuck').addClass('sticky-row--stopped');
          $stickyRow.css('top', distanceToStop - sharer + 'px');
        } else {
          $stickyRow.removeClass('sticky-row--stuck').removeClass('sticky-row--stopped').css('top', '');
        }
      });
    },
    */
    function () {
      $('.wc-forward').each(function() {
        if ($(this).hasClass('button')) {
          $(this).removeClass('button');
        }
      });
    },
  ];

  $.each(init, function (index, initFunction) {
    initFunction();
  });
});